import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// Math, math, math
// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const MathCategory = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Math' id='math' iconclass='category with-icon-paths snap-icon-maths_dual'>{/* NOSONAR */}
                <label text="Math"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

MathCategory.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default MathCategory;